<div
  class="search-results-container"
  [ngClass]="showSearchResult() || (searchResultsService.openSearch$ | async) ? 'open' : 'close'"
>
  @if (showSearchResult() || (searchResultsService.openSearch$ | async)) {
    @if (hasAnyResults()) {
      <ng-container>
        <div
          class="search-results"
          (scroll)="onResultsScroll()"
          (touchstart)="onResultsTouchStart($event)"
        >
          @if (searchResults().startPage.length) {
            <start-page-result [searchResults]="searchResults()" />
          }
          @if (searchResults().appFinder.length || searchResults().collectionFinder.length) {
            <app-finder-result
              [apps]="searchResults().appFinder"
              [collections]="searchResults().collectionFinder"
            />
          }
        </div>

        <div class="app-finder-section-container">
          <div class="app-finder-section">
            <div class="text-section">
              <b class="text-sm">
                {{
                  (platformService.isMobile()
                    ? 'start-page.search.more-title-mobile'
                    : 'start-page.search.more-title'
                  ) | translate
                }}
              </b>
              <div class="text-xs">
                {{
                  (platformService.isMobile()
                    ? 'start-page.search.more-text-mobile'
                    : 'start-page.search.more-text'
                  ) | translate
                }}
              </div>
            </div>
            <app-button
              [buttonLabel]="'App Finder'"
              [buttonType]="ButtonTypeEnum.SECONDARY"
              [icon]="'boschicon-bosch-ic-batch'"
              [isDisabled]="false"
              routerLink="{{ link }}"
            />
          </div>
        </div>
      </ng-container>
    } @else {
      <div class="app-finder-section-container">
        <div class="app-finder-section">
          <div class="text-section">
            <b class="text-sm">
              {{
                (platformService.isMobile()
                  ? 'start-page.search.more-title-mobile'
                  : 'start-page.search.more-title'
                ) | translate
              }}
            </b>
            <div class="text-xs">
              {{
                (platformService.isMobile()
                  ? 'start-page.search.more-text-mobile'
                  : 'start-page.search.more-text'
                ) | translate
              }}
            </div>
          </div>
          <app-button
            [buttonLabel]="'App Finder'"
            [buttonType]="ButtonTypeEnum.SECONDARY"
            [icon]="'boschicon-bosch-ic-batch'"
            [isDisabled]="false"
            routerLink="{{ link }}"
          />
        </div>
      </div>
    }
  }
</div>
